import React from 'react';
import clsx from 'clsx';
import { format } from 'date-fns';
import dynamic from 'next/dynamic';

const Tooltip = dynamic(() => import('../tooltip/Tooltip').then(mod => mod.Tooltip), {
  ssr: false,
});

const TooltipTrigger = dynamic(
  () => import('../tooltip/Tooltip').then(mod => mod.Tooltip.Trigger),
  { ssr: false },
);

const TooltipContent = dynamic(
  () => import('../tooltip/Tooltip').then(mod => mod.Tooltip.StyledContent),
  { ssr: false },
);

export const DateTimeTooltip = ({
  dateTime,
  children,
  className,
  prefix,
}: {
  dateTime: Date;
  children: React.ReactNode;
  className?: string;
  prefix?: string;
}) => {
  return (
    <Tooltip openOnClick={false}>
      <TooltipTrigger className={clsx('cursor-default', className)}>{children}</TooltipTrigger>
      <TooltipContent
        side="top"
        className="max-w-[208px] px-3 py-2 text-center text-base-s font-medium"
      >
        {`${prefix ? prefix : ''}${format(dateTime, 'MMM d, yyyy • hh:mm a')}`}
      </TooltipContent>
    </Tooltip>
  );
};
